import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card } from '@blueprintjs/core'

class NoMatch extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return(
            <div className='center-center'>
                <div className='nomatch pt-card pt-dark pt-interactive pt-elevation-2' onClick={() => window.location.href="/"}>
                    <i><center>
                        <h1>404</h1>
                        Click to Go Home 
                    </center></i>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps)(NoMatch)



// WEBPACK FOOTER //
// ./src/containers/NoMatch.js